import { render, staticRenderFns } from "./TextObject.vue?vue&type=template&id=3a633dfe&scoped=true&"
import script from "./TextObject.vue?vue&type=script&lang=js&"
export * from "./TextObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a633dfe",
  null
  
)

export default component.exports